
import './Ad_admissions_consultant_fileDown.scss';
import * as S from '../../scss/theme';
import fnc from '../../mymod/commFunction';
import HongButton from '../../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import HeaderTitle from '../../comm/HeaderTitle';
import Ad_admissions_consultant_viewPic from './Ad_admissions_consultant_viewPic';

import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

const Ad_admissions_consultant_fileDown = ({parentCode}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [title, setTitle] = useState(null);
  const [imgUrl, setImgUrl] = useState(null);


  useEffect(() => {
    fncSelect_list(parentCode);
  }, []);

  function fncSelect_list(parent_code) {
    if (!parentCode) return;

    fnc.sendAxios('/ad_admissions_consultantRoutes/select/consultant_agreement_fileUpload', { parent_code }, (res) => {
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        setList(newList);
      } else {
        alert('검색에 실패했습니다.');
      }
    });
  
    function getRecords(res) {
      return res.map(item => ({
        sno: item["sno"],
        title: item["title"],
        fileCode: item["fileCode"],
        fileName: item["fileName"],
        kind: item["kind"],
        sDate: fnc.formatDate2(item["sDate"])
      }));
    }
  }

  function onPreview(item) {
    const urlKey = `upload/consultant/${item.fileCode}`;
    setImgUrl(urlKey)
    setIsModal(true);
    setTitle(item.title);

  }

//=========================================
  return (
//   <S.Section>
<>
    <div className='Ad_admissions_consultant_fileDown'>
        <section className='sec-main'>
          <table className="table-hong table-main">
            <thead>
              <tr>
                <th>No</th>
                <th>제목</th>
                <th>날짜</th>
                <th>선택</th>
              </tr>
            </thead>
            <tbody>
              {list && list.map((item, index) => (
                <tr key={index} >
                  <td>{index+1}</td>
                  <td>{item.title}</td>
                  <td>{item.sDate}</td>
                  <td>
                    <HongButton
                      className="btn h-btn-dark"
                      onClick={() => onPreview(item)}
                    >
                      선택
                    </HongButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
    </div>

    {isModal && (
        <section className="">
          <Ad_admissions_consultant_viewPic imgUrl={imgUrl} setIsModal={setIsModal} />
        </section>
    )}



</>
//   </S.Section>
  );
};

export default Ad_admissions_consultant_fileDown;